import { IArticleResponse } from "../../../model/base/response/article-response";
import { IPortalCustomPageResponse } from "../../../model/base/response/portal-custom-page-response";

export enum ACTION_TYPES {
    SET_ARTICLE = 'SET_ARTICLE',
    SET_PAGE = 'SET_PAGE',
    SET_NOT_FOUND = 'SET_NOT_FOUND',
    SET_LOADING = 'SET_LOADING',
    SET_ERROR = 'SET_ERROR'
}

export interface ICustomPageState {
    /** Artigo legado (link antigo "pagina-customizada/{idArtigo}"). */
    article: IArticleResponse | null;
    /** Página customizada do APM (rota "/pagina/{slug}"). */
    page: IPortalCustomPageResponse | null;
    loading: boolean;
    error: string | null;
}

export const initialState: ICustomPageState = {
    article: null,
    page: null,
    loading: true,
    error: null
};

export type Action =
    | { type: ACTION_TYPES.SET_ARTICLE; payload: IArticleResponse }
    | { type: ACTION_TYPES.SET_PAGE; payload: IPortalCustomPageResponse }
    | { type: ACTION_TYPES.SET_NOT_FOUND }
    | { type: ACTION_TYPES.SET_LOADING; payload: boolean }
    | { type: ACTION_TYPES.SET_ERROR; payload: string };

export const customPageReducer = (state: ICustomPageState, action: Action): ICustomPageState => {
    switch (action.type) {
        case ACTION_TYPES.SET_ARTICLE:
            return { ...state, article: action.payload, page: null, loading: false, error: null };
        case ACTION_TYPES.SET_PAGE:
            return { ...state, page: action.payload, article: null, loading: false, error: null };
        case ACTION_TYPES.SET_NOT_FOUND:
            return { ...state, page: null, article: null, loading: false, error: null };
        case ACTION_TYPES.SET_LOADING:
            return { ...state, loading: action.payload };
        case ACTION_TYPES.SET_ERROR:
            return { ...state, error: action.payload, loading: false };
        default:
            throw new Error(`Unhandled action type`);
    }
};
